import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for UserStore, for use in the registry */ export const UserStoreActionTypes = [
    ActionType.FetchModernGroupMembersSucceededAction,
    ActionType.FetchModernGroupOwnersSucceededAction,
    ActionType.FetchRoamingUserDataFailedAction,
    ActionType.FetchRoamingUserDataSucceededAction,
    ActionType.FetchEntityAction,
    ActionType.FetchEntityFailedAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.FetchUserPhotoFailedAction,
    ActionType.FetchUserPhotoSucceededAction,
    ActionType.FetchUsersByKeywordAction,
    ActionType.FetchUsersByKeywordFailedAction,
    ActionType.FetchUsersByKeywordSucceededAction,
    ActionType.UpdateRoamingUserDataFailedAction,
    ActionType.UpdateRoamingUserDataSucceededAction,
    ActionType.FetchUserSettingsSucceededAction,
    ActionType.UpdateUserSettingsAction,
    ActionType.UpdateUserSettingsSucceededAction,
    ActionType.UpdateUserSettingsFailedAction,
    ActionType.FetchEntityCollectionSucceededAction
];
